import { SpinnerIcon } from '../../assets/icons';

const Spinner = () => (
    <div className='spinner-container'>
        <SpinnerIcon />
    </div>
);
export default Spinner;
